<script setup lang="ts">
</script>

<template>
  <a href="https://github.com/faeller/zulip-mobile-notifs/tree/main/worker" target="_blank" class="self-host-link">
    Easily self-host worker, free
  </a>
</template>

<style scoped>
.self-host-link {
  display: block;
  margin-top: 8px;
  color: var(--primary);
  font-size: 13px;
  text-decoration: none;
}

.self-host-link:hover {
  text-decoration: underline;
}
</style>
